"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.on = exports.emit = void 0;
var imports_1 = require("../lib/imports");
var log_sidecar_1 = require("./log-sidecar");
var map = {};
var logNamespace = 'pubsub';
function emit(actionName, data) {
    log_sidecar_1.log.x(logNamespace, 'emit', actionName);
    imports_1.l.forEach(map[actionName], function (c) {
        log_sidecar_1.log.x(logNamespace, '> on', actionName);
        c(data);
    });
}
exports.emit = emit;
function on(actionName, cb) {
    log_sidecar_1.log.x(logNamespace, 'sub', 'on', actionName);
    if (!map[actionName]) {
        map[actionName] = [];
    }
    map[actionName].push(cb);
}
exports.on = on;
